export default "__VITE_ASSET__Dci3wpcT__"